// Memory-only on purpose: the redux store is persisted to localStorage, and a persisted
// "disabled" flag is what previously made a re-enabled user impossible to let back in.
let isSignalled = false

const listeners = new Set<() => void>()

export const DISABLED_ACCOUNT_ERROR_CODE = 'USER_DISABLED'

export const markAccountDisabled = () => {
    if (isSignalled) return

    isSignalled = true
    listeners.forEach((listener) => listener())
}

export const isAccountDisabledSignalled = () => isSignalled

export const subscribeToAccountDisabled = (listener: () => void) => {
    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}
